// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"bot-with-rectangle_rectangle__Sev_b","rectangle__hovered":"bot-with-rectangle_rectangle__hovered__6GbLC"};